var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2.07199C14.5251 2.95251 15.7171 4.31167 16.391 5.93867C17.065 7.56567 17.1832 9.36958 16.7274 11.0706C16.2716 12.7717 15.2672 14.2748 13.8701 15.3468C12.4729 16.4189 10.7611 17 9 17C7.23893 17 5.52706 16.4189 4.12991 15.3468C2.73276 14.2748 1.7284 12.7717 1.2726 11.0706C0.816797 9.36958 0.935033 7.56567 1.60897 5.93867C2.2829 4.31167 3.47487 2.95251 5 2.07199M9 1V7.15377",
    stroke: "#E8C133",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/Disconnected.4fe5cedbbcd97428ed41a587531ce6b1.svg";
export { ForwardRef as ReactComponent };